import type { OriginName } from '~/interfaces/common';
import { Auth0Handler } from './auth0-handler';
import { EmailHandler } from './email-handler';
import { MetaMaskHandler } from './metamask-handler';
import { WhatsappHandler } from './whatsapp-handler';

const loginMap = {
  evm: MetaMaskHandler,
  'bloque-auth0': Auth0Handler,
  'bloque-whatsapp': WhatsappHandler,
  'bloque-whatsapp-quick': WhatsappHandler,
  'bloque-email': EmailHandler,
};

export function createLoginHandler(type: OriginName) {
  const HandlerClass = loginMap[type];
  if (!HandlerClass) {
    throw new Error(`Login type not supported: ${type}`);
  }
  return new HandlerClass(type);
}
